export const formatProposal = (proposal) => {
  const attributes = {};
  const relationships = {};
  const id = proposal.id && proposal.id !== 'dummy' ? proposal.id : undefined;

  if (proposal.operacion) {
    attributes.title = `${proposal.operacion}-${proposal.banco}`;
  }
  if (proposal.banco) {
    attributes.bank = proposal.banco;
  }
  if (proposal.titular) {
    attributes.incumbent = proposal.titular;
  }
  if (proposal.cuenta) {
    attributes.note_number = proposal.cuenta;
  }
  if (proposal.operacion) {
    relationships.id_operation = {
      data: {
        id: proposal.operacion,
        type: 'node--operation',
      },
    };
  }
  if (proposal.condiciones) {
    attributes.condiciones = proposal.condiciones.join('&');
  }
  return {
    data: {
      id,
      type: 'node--proposal',
      attributes,
      relationships,
    },
  };
};

export const processProposal = (proposal) => {
  const { attributes, id, type, relationships } = proposal;
  const proposalModel = { id, type };
  if ('title' in attributes) {
    proposalModel.title = attributes.title;
  }
  if ('bank' in attributes) {
    proposalModel.banco = attributes.bank;
  }
  if ('incumbent' in attributes) {
    proposalModel.titular = attributes.incumbent;
  }
  if ('note_number' in attributes) {
    proposalModel.cuenta = attributes.note_number;
  }
  if ('id_operation' in attributes) {
    proposalModel.operacion = attributes.id_operation;
  }
  if ('condiciones' in attributes) {
    proposalModel.condiciones = attributes.condiciones;
  }
  if ('pdf' in relationships) {
    proposalModel.pdf = relationships.pdf.data.id;
  }
  return proposalModel;
};

export const processProposalResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(proposal =>
      processProposal(proposal));
  }
  return processProposal(res.data.data);
};

export const processPdfResponse = (res) => {
  const { attributes } = res.data.data;
  let url = '';
  if ('url' in attributes) {
    url = attributes.url;
  }
  return url;
};



// WEBPACK FOOTER //
// ./src/features/propuesta-no-vinculante/utils.js